var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"white-background main-listing-page",class:[_vm.customClass],attrs:{"fluid":""}},[_vm._t("body")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }